export const config = {
  pwaWidth: 480,
};

export const traitList = [
  "Pram",
  "Puppy",
  "Puppy friendly",
  "Sweet",
  "Level headed",
  "Vocal",
  "Fast paced",
  "Polite",
  "Extrovert",
  "Special needs",
  "Goofy",
  "Playful",
  "Introvert",
  "Calm",
  "Spicy",
  "Shy",
  "Excitable",
  "Need time",
  "Sassy",
  "Confident",
  "Teen",
  "Easily distracted",
  "Senior",
  "Adult",
  "Muzzle",
  "Tripod",
];

export const masterType = ["dog family", "dog parent", "dog mum", "dog dad"];

export const allowedImageTypes = ["image/jpeg", "image/png", "image/webp"];

export enum QuestionKeyList {
  aboutThem = "ABOUT_THEM",
  myDreamDay = "MY_DREAM_DAY",
  myFavThings = "MY_FAV_THINGS",
}

export const storageKey = {
  geoLocPerm: "geoloc_permission",
  pushNotifPerm: "push_notif_permission",
  userLocation: "userLocation",
  deviceToken: "deviceToken",
  accessToken: "accessToken",
  refreshToken: "refreshToken",
};
